module.exports = __webpack_public_path__ + "img/av283.adf3b9cd.png";